import React, { useEffect } from 'react'
import {
  CourseView,
  CollectionSettings,
  CollectionShare,
  Analytics,
  Learners,
} from './components'
import { useParams } from 'react-router-dom'
import { LandingPagePreviewMain } from 'src/components/landing-page'
import LandingPageEditor from 'src/components/landing-page/landing-page-editor'
import { useSelector } from 'react-redux'
import { getCollectionCourseList } from 'src/reducers/collection/action'
import { useDispatch } from 'react-redux'
import { getCollectionSettingsAction } from 'src/reducers/collection/action'
const CollectionPageView = () => {
  const { page, subPage } = useParams() // This will get the id from the URL
  const { id } = useParams()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getCollectionCourseList(id))
    dispatch(getCollectionSettingsAction(id))
  }, [id])

  const courses = useSelector(state => state.collection.courses)
  switch (page) {
    case 'mini-courses':
      return <CourseView courses={courses} />
    case 'landing-page':
      if (subPage) {
        return <LandingPageEditor />
      }
      return <LandingPagePreviewMain />
    case 'settings':
      return <CollectionSettings />
    case 'share':
      return <CollectionShare />
    case 'analytics':
      return <Analytics />
    case 'learners':
      return <Learners />
    default:
      return <CourseView courses={courses} />
  }
}

export default CollectionPageView
